import React, { useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../SharedComponents/Header/Header';
import { AuthContext } from '../UserContext';

const Login = () => {

  const { logInUser } = useContext(AuthContext)

  const location = useLocation();
  const navigate = useNavigate()
  const from = location.state?.from?.pathname || "/";



  const handleOnsubmit = e =>{
    e.preventDefault();

    const form = e.target;
    const email = form.email.value;
    const password = form.password.value;

    logInUser(email, password)
    .then(result => {})
    .catch(error=>console.error(error))
    navigate(from, { replace: true });
  }


  return (
    <div>
      <Header></Header>
      <section className="bg-white">
        <div className="">
          <main
            className="flex items-center justify-center h-[100vh] mx-3 md:mx-0"
          >
            <div className="max-w-xl lg:max-w-3xl">
              

              <h1
                className="text-2xl font-bold text-gray-900 sm:text-3xl md:text-4xl"
              >
                Welcome to <Link to={'/'} className='text-blue-600'>Dragon News! </Link>
                 Please LogIn!!
              </h1>

              <p className="mt-4 leading-relaxed text-gray-500">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eligendi nam
                dolorum aliquam, quibusdam aperiam voluptatum.
              </p>

              <form onSubmit={handleOnsubmit} className="mt-8 grid grid-cols-6 gap-6">
                

                <div className="col-span-6">
                  <label className="block text-sm font-medium text-gray-700">
                    Email
                  </label>

                  <input
                    type="email"
                    name="email"
                    className="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm p-2 border-2"
                  />
                </div>

                <div className="col-span-6">
                  <label
                    className="block text-sm font-medium text-gray-700"
                  >
                    Password
                  </label>

                  <input
                    type="password"
                    id="Password"
                    name="password"
                    className="mt-1 w-full rounded-md border-gray-200 bg-white text-sm text-gray-700 shadow-sm p-2 border-2"
                  />
                </div>


                <div className="col-span-6">
                  <label className="flex gap-4">
                    <input
                      type="checkbox"
                      id="MarketingAccept"
                      name="marketing_accept"
                      className="h-5 w-5 rounded-md border-gray-200 bg-white shadow-sm"
                    />

                    <span className="text-sm text-gray-700">
                      I want to receive emails about events, product updates and
                      company announcements.
                    </span>
                  </label>
                </div>

                

                <div className="col-span-6 sm:flex sm:items-center sm:gap-4">
                  <button
                    type='submit'
                    className="inline-block shrink-0 rounded-md border border-blue-600 bg-blue-600 px-12 py-3 text-sm font-medium text-white transition hover:bg-transparent hover:text-blue-600 focus:outline-none focus:ring active:text-blue-500"
                  >
                    Log In
                  </button>

                  <p className="mt-4 text-sm text-gray-500 sm:mt-0">
                    Don't have an account?
                    <Link to={'/register'} className="text-gray-700 underline"> Create an account</Link>.
                  </p>
                </div>
              </form>
            </div>
          </main>
        </div>
      </section>

    </div>
  );
};

export default Login;